import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts  string with new lines to an HTML string where each line
 * is enclosed by <p></p>
 *
 */
@Pipe({
    name: "newlineToParagraph",
    standalone: true
})
export class NewlineToParagraphPipe implements PipeTransform {
  transform(text: string, args?: any): string {
    // Copied from: https://stackoverflow.com/a/36773193/386619
    let regexp: RegExp = /(<([^>]+)>)/i;

    // If the string is already HTML, do nothing and return it back
    if (regexp.test(text)) {
      return text;
    }

    // Since the string is not HTML, split out the strings by new line
    // and reassemble them as paragraph elements
    var lines = text.split(/\r\n|\r|\n/);

    // console.log(lines);

    let html = '';

    // 

    lines.forEach((x) => {
      if (x) {
        let p = `<p>${x.trim()}</p>`;
        html = html + p;
      }
    });

    return html;
  }
}
